import { call, put, takeLatest, fork, all, delay, } from 'redux-saga/effects';
import * as Types from '../constants/Types';
import * as HomestayService from '../services/homestayService';
import i18n from '../constants/initLng';
import * as Func from "../helpers/functions";
import history from '../helpers/history';
import { PATHS, SAGA_DELAY_TIMEOUT } from '../constants/Define';
import { omit } from 'lodash';
import {
    setListHomestays as setListHomestaysAction,
    setHomestayDetail as setHomestayDetailAction,
    setAllHomestays,
    setTagGroupDetailSku,
    setAllHomestayActive,
    setListRateCompare
} from '../actions/homestayAction';

function* getListHomestay() {
    yield takeLatest(Types.HOMESTAY_LIST_ACTION, Func.sagaWrapper(function* (action) {
        const limit = action.filters.pageSize ? action.filters.pageSize : undefined;
        const offset = action.filters.pageIndex ? (action.filters.pageIndex - 1) * limit : undefined;
        const params = {
            ...omit(action.filters, ['pageIndex', 'pageSize']),
            limit, offset,
        }
        yield delay(SAGA_DELAY_TIMEOUT);
        const result = yield call(HomestayService.getHomestays, params);
        yield put(setListHomestaysAction(result));
    }, errorHandleHomestay(Types.HOMESTAY_LIST_FAIL)))
}

function* getListHomestayActive() {
    yield takeLatest(Types.HOMESTAY_ALL_ACTIVE_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(HomestayService.getAllHomestaysActive, action.params);
        yield put(setAllHomestayActive(result.data));
    }, errorHandleHomestay(Types.HOMESTAY_ALL_ACTIVE_FAIL)))
}

function* getHomestayDetail() {
    yield takeLatest(Types.HOMESTAY_DETAIL_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(HomestayService.getHomestayDetail, action.id);
        yield put(setHomestayDetailAction(result));
    }, errorHandleHomestay(Types.HOMESTAY_DETAIL_FAIL)))
}

function* updateHomestayDetail() {
    yield takeLatest(Types.HOMESTAY_DETAIL_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(HomestayService.updateHomestayDetail, action.homestay);
        Func.sagaSuccessMessage({ action, message: `${i18n.t('notification.updateSuccess')}`, description: `${i18n.t('item.homestay.title')} "${action.homestay.name}"` })
        yield put(setHomestayDetailAction(action.homestay));
        yield put({ type: Types.HOMESTAY_DETAIL_ACTION, id: action.homestay.id });
    }, errorHandleHomestay(Types.HOMESTAY_DETAIL_FAIL)))
}

function* createHomestayDetail() {
    yield takeLatest(Types.HOMESTAY_DETAIL_CREATE_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(HomestayService.createHomestayDetail, action.homestay);
        Func.sagaSuccessMessage({ action, message: `${i18n.t('notification.createSuccess')}`, description: `${i18n.t('item.homestay.title')} "${action.homestay.name}"` })
        yield put(setHomestayDetailAction(action.homestay));
    }, errorHandleHomestay(Types.HOMESTAY_DETAIL_FAIL)))
}

// TRANSLATE
function* createHomestayTranslate() {
    yield takeLatest(Types.HOMESTAY_CREATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(HomestayService.createHomestayTranslate, action.homestay);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.201'), action.homestay.translate.languageName);
        yield put({ type: Types.HOMESTAY_CREATE_TRANSLATE_SUCCESS });
        yield put({ type: Types.HOMESTAY_DETAIL_ACTION, id: action.homestay.id });
    }, errorHandleHomestay(Types.HOMESTAY_FAIL)))
}

function* updateHomestayTranslate() {
    yield takeLatest(Types.HOMESTAY_UPDATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(HomestayService.updateHomestayTranslate, action.homestay);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'), action.homestay.translate.languageName);
        yield put({ type: Types.HOMESTAY_UPDATE_TRANSLATE_SUCCESS });
        yield put({ type: Types.HOMESTAY_DETAIL_ACTION, id: action.homestay.id });
    }, errorHandleHomestay(Types.HOMESTAY_FAIL)))
}

function* deleteHomestayTranslate() {
    yield takeLatest(Types.HOMESTAY_DELETE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(HomestayService.deleteHomestayTranslate, action.homestay.translate.id);
        Func.sagaSuccessMessage(action, i18n.t('notification.removeSuccess'), action.homestay.translate.languageName);
        yield put({ type: Types.HOMESTAY_DELETE_TRANSLATE_SUCCESS });
        yield put({ type: Types.HOMESTAY_DETAIL_ACTION, id: action.homestay.id });
    }, errorHandleHomestay(Types.HOMESTAY_FAIL)))
}

function* getTagGroupDetailSku() {
    yield takeLatest(Types.HOMESTAY_TAG_GROUP_DETAIL_SKU_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(HomestayService.getTagroupDetailSKU, action.id);
        yield put(setTagGroupDetailSku(result));
    }, errorHandleHomestay(Types.HOMESTAY_DETAIL_FAIL)))
}

function* updateTagroupDetailSKUActive() {
    yield takeLatest(Types.HOMESTAY_TAG_GROUP_DETAIL_SKU_ACTIVE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(HomestayService.updateTagroupDetailSKUActive, action.data);
        yield put({ type: Types.HOMESTAY_TAG_GROUP_DETAIL_SKU_ACTION, id: action.id });
    }, errorHandleHomestay(Types.HOMESTAY_DETAIL_FAIL)))
}

function errorHandleHomestay(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {
        yield put({ type: errorActionType })
    }, 'homestay');
}

function* getAllHomestay() {
    yield takeLatest(Types.HOMESTAY_All_ACTION, Func.sagaWrapper(function* (action) {
        yield delay(SAGA_DELAY_TIMEOUT);
        const result = yield call(HomestayService.getAllHomestays);
        yield put(setAllHomestays(result));
    }, errorHandleHomestay(Types.HOMESTAY_All_FAIL)))
}

function* clearCacheHomestay() {
    yield takeLatest(Types.CLEAR_CACHE_ACTION, Func.sagaWrapper(function* (action) {
        const params = {
            type: action.value,
        }
        yield call(HomestayService.clearCache, params);
        Func.sagaSuccessMessage(action, i18n.t('validation.clearCacheSuccess'));
        yield put({ type: Types.CLEAR_CACHE_SUCCESS })
    }, errorHandleHomestay(Types.HOMESTAY_All_FAIL)))
}

function* setListRateCompareSaga() {
    yield takeLatest(Types.RATE_LIST_COMPARE_ACTION, Func.sagaWrapper(function* (action) {
        // yield delay(SAGA_DELAY_TIMEOUT);
        const result = yield call(HomestayService.getRateCompare, action.filters);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.200'));
        yield put(setListRateCompare(result));
    }, errorHandleHomestay(Types.RATE_LIST_COMPARE_FAIL)))
}

function* createRateCompare() {
    yield takeLatest(Types.RATE_LIST_COMPARE_CREATE_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        yield call(HomestayService.createRateCompare, action.data);
        Func.sagaSuccessMessage({ action, message: `${i18n.t('notification.createSuccess')}`, description: `${i18n.t('item.rateCompare.title')}` })
        history.push(PATHS.RATE_COMPATE.LIST.path.replace(':homestay_id', action.data.homestayId));
        history.go();
    }, errorHandleHomestay(Types.RATE_LIST_COMPARE_FAIL)))
}

function* updateRateCompare() {
    yield takeLatest(Types.RATE_LIST_COMPARE_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        yield call(HomestayService.updateRateCompare, action.data);
        Func.sagaSuccessMessage({ action, message: `${i18n.t('notification.updateSuccess')}`, description: `${i18n.t('item.rateCompare.title')}` })
        history.push(PATHS.RATE_COMPATE.LIST.path.replace(':homestay_id', action.data.dataRateCompare.homestayId));
        history.go();
    }, errorHandleHomestay(Types.RATE_LIST_COMPARE_FAIL)))
}

function* deleteRateCompare() {
    yield takeLatest(Types.RATE_LIST_COMPARE_DELETE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(HomestayService.deleteRateCompare, action.data.id);
        Func.sagaSuccessMessage(action, i18n.t('notification.removeSuccess'));
        yield put({ type: Types.RATE_LIST_COMPARE_ACTION, filters: action.data.filters })
    }, errorHandleHomestay(Types.RATE_LIST_COMPARE_FAIL)));
}

export function* homestaySaga() {
    yield all([
        fork(getAllHomestay),
        fork(getListHomestay),
        fork(getHomestayDetail),
        fork(updateHomestayDetail),
        fork(createHomestayDetail),

        fork(createHomestayTranslate),
        fork(updateHomestayTranslate),
        fork(deleteHomestayTranslate),
        fork(getTagGroupDetailSku),
        fork(updateTagroupDetailSKUActive),
        fork(getListHomestayActive),

        fork(clearCacheHomestay),

        fork(setListRateCompareSaga),
        fork(createRateCompare),
        fork(updateRateCompare),
        fork(deleteRateCompare),
    ])
}
